/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import pic from "../../../allResources/img/video.png";
import {Table, Input, Checkbox, Button, Select, Divider, Pagination} from "antd";
import OptionRange from "../../components/fileLibrary/option/OptionRange";
import PageTableComponent from "../../components/pageTable/PageTable";
import Titlepicfile from "../../../components/titlepicfile/Titlepicfile";
import {formatTime, uuid} from "../../../../utils";
import {configImgList} from './config/configImgList'
import {HEADER_HEIGHT} from "../../../../constants";
import {message} from '../../components/Mess'
import $ from "jquery";
import Detailpage from "../../components/DetailPage";
const { Search } = Input;
const { Option } = Select;



export default class Story extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state={
            params:{
                pageNum: 1,
                pageSize: 10,
                keyword:"",
            },
            data:[],
            count:0, //表格数据长度
            modalKey:uuid(),
            currentName:'',// 获取路径是公共资源还是全部资源
            selectedRowKeys: [],//选中的数组
            checkList:[],
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
         let currentName =   this.props.match.params.story;
         this.setState({currentName:currentName},()=>{
             this.getList()
         });
    }
    render() {

        let height =  document.body.clientHeight - HEADER_HEIGHT-32;
        return (
            <div style={{background:'#ffffff',
                margin: "15px 0 15px 15px",
                padding:'0px 15px',
                position: 'relative',
                // height:height,
                maxHeight: "calc(100vh - 100px)",
                paddingBottom: "15px",
                borderRadius:5}}>
                {/*搜索条件*/}
                {this.renderCondition()}
                {/*渲染选择框以及下载 功能*/}
                {this.renderBtn()}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }
    renderCondition(){
        let configs = ['path','company','media','fileTime'];
        return(
            <div>
                <div style={{height: '48px', borderBottom: '1px solid rgba(0, 0, 0, 0.15)', lineHeight: '55px'}}> <OptionRange
                    configs={configs}
                    purpose={'story'}
                    configName={this.state.indexName}
                    onClickCall={(data) => {
                        this.changeStatus(data)
                    }}/>

                </div>
                <Divider style={{margin:0}}/>
            </div>
        )
    }
    //切换上面的选择
    changeStatus(config){
        let {params} = this.state;
        let flag = false;
        if(config && config.length) {
            config.forEach(item=>{

                if(item.data.toString().indexOf('不限')>-1){
                    if(params[item.type] != undefined) {
                        flag = true;
                    };
                    delete params[item.type]
                }else{
                    if (item.data || item.data === 0) {
                        if(params[item.type] != item.data) {
                            flag = true;
                        };
                        params[item.type] = item.data;
                    } else {
                        if(params[item.type] != undefined) {
                            flag = true;
                        };
                        delete params[item.type]
                    }
                }
            })
        }
        if(flag) {
            this.state.params.pageNum =1;
            this.state.params.pageSize =10;
           this.setState({},()=>{
               this.getList()
           })

        }
    }
    renderBtn(){
        return(
            <div style={{display:'flex',alignItems: "center",padding:"24px 32px 0px 0px"}}>
                <div className={'storyInput'}><Search
                        placeholder="请输入关键词"
                        allowClear={true}
                        value={this.state.params.keyword}
                        onSearch={value => {
                            this.state.params.keyword = value;
                            this.state.params.pageNum = 1;
                            this.setState({}, () => {
                                this.getList()
                            })
                        }}
                        onChange={(e) => {
                            this.state.params.keyword = e.target.value;
                            this.setState({})
                        }}
                        style={{ width: 500, }}
                    /></div>

                <div style={{
                    display: "flex",
                    justifyContent: "end",
                    width:" 100%",
                    flexDirection:'row-reverse',
                }}><Button  icon="download" onClick={()=>{
                    this.download(this.state.checkList)
                }}>下载</Button></div>
                <style>{`.storyInput .ant-input{background:#f5f8fc}`}</style>
            </div>
        )
    }
    renderData(){
        let  columns=[
            {
                title: '标题',
                dataIndex: 'title',
                ellipsis: true,
                render: (text, record) =>{
                   let summary = record.variableFields&&record.variableFields.summary?record.variableFields.summary:null;
                    return (<div style={{display: 'flex'}}>
                        {record && record.titlePic && record.titlePic !="" ?
                        <div style={{borderRadius: '5px',marginRight:16}}>
                            <Titlepicfile
                                borderRadius= {5}
                                style={{width: '56px', height: '56px', objectFit: "contain", }}
                                src={record.titlePic}/>
                        </div> : ""}
                        <div style={{ width:'92%', }}>
                            <div className={'twoText'} title={text} onClick={()=>{
                              this.getDetailPage(record)
                            }} style={{
                                color: "rgba(0, 0, 0, 0.85)",
                                fontSize: "16px",
                                cursor: "pointer",
                                lineHeight: "22px",
                                width:record.titlePic && record.titlePic !=""?'94%':'100%',
                            }}>{text}</div>
                            <div className={'oneText'}  title={summary} style={{
                                marginTop: '8px',
                                fontSize: "14px",
                                lineHeight: "22px",
                                width:record.titlePic && record.titlePic !=""?'94%':'100%',
                                color: 'rgba(0, 0, 0, 0.65)'
                            }} >{summary}
                            </div>
                        </div>
                    </div>)
                }
            },
            {
                title: '创建单位',
                dataIndex: 'deptName',
                width:"150px",
                ellipsis: true,
            },
            {
                title: '发布媒体',
                dataIndex: 'mediaNames',
                width:"200px",
                render:(text,record)=>{
                    return (
                        <div>
                            {text&&text.length&&text.map((item,index)=>{
                                return <div style={{display:"flex",alignItems: "center",}} title={item} key={index}>
                                    <img src ={configImgList[record.type]}  style={{width:'16px',height:'16px',objectFit: "contain",position: "relative", top: '1px'}}/>
                                    <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginLeft:'2px'}}>{item}</span>
                                </div>
                            })}
                        </div>

                       )
                }
            },
            {
                title: '发布时间',
                dataIndex: 'updateTime',
                width:"150px",
                render:(text,record)=>{
                    return (<div style={{height:84,lineHeight:"84px"}}>{/\d{4}-\d{1,2}-\d{1,2}/g.exec(formatTime(text))}</div>)
                }
            },
            {
                title: '操作',
                dataIndex: 'address',
                width:"150px",
                render: (text,record) =>{
                    return (<div style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>
                        <span style={{ cursor:"pointer" }} onClick={()=>{this.getDetailPage(record)}}>查看</span>
                        <span style={{marginLeft:'16px',cursor:"pointer"}} onClick={()=>{
                            this.download([record])
                        }}>下载</span>
                    </div>)
                }},
        ];
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.state.checkList = selectedRows;
                this.setState({}, () => {

                })
            },
        };
        return(
            <div >
                <PageTableComponent columns={columns}
                                    calssName={'storyTable'}
                                    rowSelection={rowSelection}
                                    data={this.state.data}
                                    page={this.state.params.pageNum}
                                    size={this.state.params.pageSize}
                                    count={this.state.count}
                                    positionHeight = {80}
                                    onChangePage={(page, size) => {
                                        this.onChangePage(page, size)
                                    }}
                ></PageTableComponent>
                <style>{`.storyTable .ant-table-thead > tr > th, .ant-table-tbody > tr > td{padding: 2px 16px}`}</style>
                <Detailpage   key={this.state.modalKey} onRef={(Detailpage) => this.setDetailpage = Detailpage}
                              story ={true}
                              onCloseCall={() => {
                                  this.setState({modalKey: uuid()})
                              }}
                              dataList={this.state.data}></Detailpage>
            </div>
        )
    }

    getDetailPage(item) {
        this.setDetailpage.show(true,item)
    }
   //获取列表
    getList() {
        let url;
        if(this.state.currentName === 'public'){
            url = "/search-server/search/getList/story/public"
        }else if(this.state.currentName === 'all'){
            url = "/search-server/search/getList/story/all"
        }
        let {params} =this.state;
        this.request({
            url: url,
            method: "post",
            body: params,
            loading: false,
            contentType: 'json',
            callBack: (data) => {
               let array=[];
                if(data&&data.data&&data.data.length){
                    array = data.data
                }
                this.setState({data:array,count:data.count},()=>{
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })
            }
        });

    };
    //分页
    onChangePage(page, page_size) {
        this.setState({
            selectedRowKeys:[]
        })
        this.state.params.pageNum = page;
        this.state.params.pageSize = page_size;
        this.state.checkList= [];
        this.getList();
    }

  //单个下载
    download=(checkList)=>{
        if (!checkList.length) {
            message.destroy()
            message.warning('至少选择一篇稿件！');
            return false
        }
        this.request({
            url: "/cm-sites-storage-management/home/downloadStory",
            method: "downloadPost",
            body: checkList,
            loading: false,
            contentType: 'json',
            callBack: (data) => {
                let array = [];
                if (data && data.data && data.data.length) {
                    array = data.data
                }
                this.setState({data: array, count: data.count}, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })
            }
        });


    }
}
